<template>
  <v-card outlined class="pa-2 w-100">
    <div class="text-caption mb-2">{{ label }}</div>
    <v-btn-toggle dense class="mb-2">
      <v-btn x-small :disabled="disabled" @click="applyFormat('bold')">
        <v-icon small>mdi-format-bold</v-icon>
      </v-btn>
      <v-btn x-small :disabled="disabled" @click="applyFormat('italic')">
        <v-icon small>mdi-format-italic</v-icon>
      </v-btn>
      <v-btn x-small :disabled="disabled" @click="applyFormat('underline')">
        <v-icon small>mdi-format-underline</v-icon>
      </v-btn>
      <v-btn x-small :disabled="disabled" @click="applyFormat('insertUnorderedList')">
        <v-icon small>mdi-format-list-bulleted</v-icon>
      </v-btn>
      <v-btn x-small :disabled="disabled" @click="applyFormat('insertOrderedList')">
        <v-icon small>mdi-format-list-numbered</v-icon>
      </v-btn>
      <v-btn x-small :disabled="disabled" @click="applyFormat('removeFormat')">
        <v-icon small>mdi-format-clear</v-icon>
      </v-btn>
    </v-btn-toggle>

    <div
      ref="editor"
      class="html-editor"
      :class="{ 'html-editor--disabled': disabled }"
      :contenteditable="!disabled"
      @input="emitContent"
      @blur="emitContent"
      @paste="onPaste"
    ></div>
  </v-card>
</template>

<script>
export default {
  name: "HtmlEditorField",
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(newValue) {
      if (!this.$refs.editor) {
        return;
      }

      if (this.$refs.editor.innerHTML !== (newValue || "")) {
        this.$refs.editor.innerHTML = newValue || "";
      }
    }
  },
  mounted() {
    this.$refs.editor.innerHTML = this.value || "";
  },
  methods: {
    applyFormat(command) {
      if (this.disabled) {
        return;
      }

      this.$refs.editor.focus();
      document.execCommand(command, false, null);
      this.emitContent();
    },
    emitContent() {
      this.$emit("input", this.$refs.editor.innerHTML);
    },
    onPaste(event) {
      if (this.disabled) {
        return;
      }

      // Keep pasted content plain text to avoid broken markup from external sources.
      event.preventDefault();
      const text = (event.clipboardData || window.clipboardData).getData("text");
      document.execCommand("insertText", false, text);
      this.emitContent();
    }
  }
};
</script>

<style scoped>
.html-editor {
  min-height: 180px;
  border: 1px solid #9e9e9e;
  border-radius: 4px;
  padding: 10px;
  outline: none;
  background: rgba(255, 255, 255, 0.04);
}

.html-editor--disabled {
  background: rgba(120, 120, 120, 0.2);
  cursor: not-allowed;
}
</style>



